import { render, staticRenderFns } from "./HelpDesk.vue?vue&type=template&id=13c3e058&scoped=true&"
import script from "./HelpDesk.vue?vue&type=script&lang=js&"
export * from "./HelpDesk.vue?vue&type=script&lang=js&"
import style0 from "./HelpDesk.vue?vue&type=style&index=0&id=13c3e058&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c3e058",
  null
  
)

export default component.exports